export function PurplePin({ size = 16 }: { size?: number }) {
  return (
    <svg width={size * 0.69} height={size} viewBox="0 0 24 35" fill="none">
      <path
        d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
        fill="white"
      />
      <path
        d="M12.4238 0.00729492C5.60211 -0.232241 0 5.45822 0 12.5119C0 20.517 7.37299 26.3266 11.5055 34.6816C11.7154 35.1058 12.3014 35.1063 12.512 34.6822C16.2505 27.1644 22.64 22.1233 23.8242 14.8808C25.0502 7.38623 19.7162 0.263459 12.4238 0.00729492ZM12.0082 19.0656C8.53437 19.0656 5.7182 16.1313 5.7182 12.5119C5.7182 8.89248 8.53444 5.95815 12.0082 5.95815C15.482 5.95815 18.2982 8.89248 18.2982 12.5119C18.2982 16.1313 15.482 19.0656 12.0082 19.0656Z"
        fill="#8A3DFF"
      />
    </svg>
  )
}
